// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".em-well{background-color:#fff;border-radius:4px;box-shadow:0 2px 2px 0 rgba(34,34,34,.08)}", ""]);
// Exports
module.exports = exports;
